<app-failure-guidance [transactionId]="transactionId"></app-failure-guidance>
